export const BILLING_READ = "billing.read";
export const BILLING_POST = "billing.post";
export const BILLING_PAYMENTS = "billing.payments";
export const BILLING_ADJUST = "billing.adjust";
export const BILLING_WRITEOFF = "billing.writeoff";
export const BILLING_RUNS = "billing.runs";
export const BILLING_CLOSE = "billing.close";
export const BILLING_SETTINGS = "billing.settings";
export const BILLING_REPORTS = "billing.reports";
export const EXPENSES_READ = "expenses.read";
export const EXPENSES_WRITE = "expenses.write";
